import { type PartnerOfferStatus } from '@/api/routes/partners/partners.offers.api';
import Chip from '@/components/Chip';
import { OFFER_STATUS_CHIP, offerStatusLabel } from '@/domain/offers/utils';

interface Props {
  status: PartnerOfferStatus;
}

/** Status chip shared by the offers list and detail (P18). */
const OfferStatusChip = ({ status }: Props) => (
  <Chip size="xsmall" label={offerStatusLabel[status]} {...OFFER_STATUS_CHIP[status]} />
);

export default OfferStatusChip;
